// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  heroId: __t.u64().name("hero_id"),
  owner: __t.identity(),
  encounterId: __t.u64().name("encounter_id"),
  wonder: __t.string(),
  options: __t.array(__t.u16()),
  names: __t.array(__t.string()),
  blurbs: __t.array(__t.string()),
  chosen: __t.option(__t.u8()),
  at: __t.timestamp(),
});
